import { type } from 'arktype';

export const SLOT_OVERLAP_CONFLICT_CODE = 'SLOT_OVERLAP_CONFLICT';
export const SLOT_TYPE_RECURRENCE_UNSUPPORTED_CODE = 'SLOT_TYPE_RECURRENCE_UNSUPPORTED';

export const SLOT_OVERLAP_HORIZON_DAYS = 366;

const slotOverlapPartySchema = type({
  slotId: 'string',
  type: type('string').configure({ description: 'Slot type key; `untyped` for entries without a type.', examples: ['external-booking'] }),
  date: type('string').configure({
    description: 'Occurrence date (YYYY-MM-DD); the expanded date for recurring slots.',
    examples: ['2026-11-04'],
  }),
  startTime: 'string',
  endTime: 'string',
  effectiveStartTime: type('string').configure({ description: '`startTime` minus the brief margin.' }),
  effectiveEndTime: type('string').configure({ description: '`endTime` plus the debrief margin.' }),
  briefMinutes: 'number.integer',
  debriefMinutes: 'number.integer',
}).configure({ description: 'One side of a slot overlap.' });
export type SlotOverlapParty = typeof slotOverlapPartySchema.infer;

export const slotOverlapConflictSchema = type({
  calendarId: 'string.uuid',
  policy: type("'warn'|'conflict'").configure({ description: 'Resolved overlap policy of the pair; `allow` never produces an entry.' }),
  first: slotOverlapPartySchema,
  second: slotOverlapPartySchema,
}).configure({ description: 'Two entries of one calendar whose effective ranges overlap.' });
export type SlotOverlapConflict = typeof slotOverlapConflictSchema.infer;

export const slotOverlapConflictErrorSchema = type({
  code: `'${SLOT_OVERLAP_CONFLICT_CODE}'`,
  conflicts: slotOverlapConflictSchema.array(),
}).configure({ description: '409 body of a slot write blocked by a `conflict` overlap policy.' });

export const slotConflictsQuerySchema = type({
  from: type('string').configure({ description: 'First date of the range (YYYY-MM-DD, inclusive).', examples: ['2026-11-01'] }),
  to: type('string').configure({ description: 'Last date of the range (YYYY-MM-DD, inclusive).', examples: ['2026-11-30'] }),
}).configure({ description: 'Query parameters for listing overlap conflicts of a calendar.' });

export const slotConflictsResponseSchema = type({
  conflicts: slotOverlapConflictSchema.array(),
}).configure({ description: 'Existing `warn` and `conflict` overlaps of one calendar, recurring slots expanded.' });
export type SlotConflictsResponse = typeof slotConflictsResponseSchema.infer;
